export const ADD_VEHICLE_DEFAULT_VALUES = {
  PartyType: null,
  ptsParentID: null,

  PlateNumber: '',
  PlateState: '',
  PlateType: '',
  PlateExpiration: null,
  ptsPlateIssuingAuthorityID: null,
  ptsAddressID: null,
  PlateColor: '',
  PlateBackgroundText: '',
  PlateStatus: '',
  DecalExpiration: null,
  PlateDetail: '',

  Year: '',
  Make: '',
  Model: '',
  Style: '',
  DoorQuantity: '',
  PassengerSafeQty: '',
  SeatQty: '',
  PrimaryColor: '',
  SecondaryColor: '',
  InteriorColor: '',
  Classification: '',
  Description: '',
  Brand: '',
  Brander: '',

  VIN: '',
  VINAnalysisText: '',
  PropertyID: '',
  Property: '',
  CommercialID: '',
  Commercial: '',
  EmissionInspectionQty: '',
  Transmission: '',
  IsCMVIndicator: false,

  IsRented: false,
  IsWanted: false,
  GarageIndicator: false,
  GarageFacility: '',

  TitleText: '',
  InsuranceCompany: '',
  VehicleValue: '',
  OdometerReading: '',
  GrossWeightMeasure: '',
  IsPermanentReg: false,
  RoadIndicator: false,
  IsLeased: false,
  LesseeType: null,
  ptsLesseeID: null,
  LessorType: null,
  ptsLessorID: null,
};

export const VEHICLE_TAB_KEYS = {
  BULLETINS: 'bulletins',
  REGISTRATIONS: 'registrations',
  EDIT: 'edit',
  TOWING: 'towing',
  ATTACHMENTS: 'attachments',
};

export const EDIT_VEHICLE_DEFAULT_VALUES = {
  Year: '',
  Make: '',
  Model: '',
  Style: '',
  DoorQuantity: '',
  PassengerSafeQty: '',
  SeatQty: '',
  PrimaryColor: '',
  SecondaryColor: '',
  InteriorColor: '',
  Classification: '',
  Description: '',
  Brand: '',
  Brander: '',

  VIN: '',
  VINAnalysisText: '',
  PropertyID: '',
  Property: '',
  CommercialID: '',
  Commercial: '',
  EmissionInspectionQty: '',
  Transmission: '',
  IsCMVIndicator: false,

  IsRented: false,
  IsWanted: false,
  GarageIndicator: false,
  GarageFacility: '',
};
